<template>
    <div>
        <v-card>
            <v-card-title>Status Updates</v-card-title>

            <v-list two-line>

                <v-list-item v-for="status in booking.statuses" :key="status.id" >

                    <v-list-item-content>
                    <v-list-item-title>{{status.createdAt | formatDate('D MMM, YY @ hh:mm' )}}</v-list-item-title>

                    <v-list-item-subtitle><BookingStatusChip :value="status" small/> {{status.reason}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-card>
    </div>
</template>

<script>
    import BookingStatusChip from "./BookingStatusChip";
    export default {
        components: {BookingStatusChip},
        props: {
            booking: Object,
        },

    }
</script>

<style scoped>

</style>